<template>
  <b-container fluid class="mt-3">
    <div class="card shadow">
      <div class="card-body">
        <div class="d-flex justify-content-center" v-if="isLoading">
          <div class="loading"></div>
        </div>
        <div class="row" v-else>
          <div
            class="col-lg-4 col-xl-4"
            v-for="(value, key) in metriques"
            :key="key"
          >
            <router-link
              :to="{
                name: 'metrique-detail',
                params: { type_input: value.type_input },
              }"
            >
              <stats-card
                :title="key"
                :sub-title="value.value"
                type="gradient-teal"
                icon="fas fa-chart-bar"
                class="mb-4"
              ></stats-card>
            </router-link>
          </div>

          <div
            class="col-lg-4 col-xl-4"
            v-for="(value, key) in metriques.taux_utilisation_filtre"
            :key="key"
          >
            <router-link :to="{ name: 'metrique-detail' }">
              <stats-card
                :title="'Filtre: ' + key"
                :sub-title="value + '%'"
                type="gradient-warning"
                icon="fas fa-filter"
                class="mb-4"
              >
              </stats-card>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Accountants",
  computed: {
    ...mapGetters([
      "file",
      "hasAdminRole",
      "hasMedecinControleRole",
      "hasAssistante",
      "hasPatientRole",
      "hasPraticienRole",
      "hasSouscripteurRole",
      "hasGestionnaireRole",
      "metriques",
    ]),

    can: function () {
      return (
        this.hasAdminRole ||
        this.hasGestionnaireRole ||
        this.hasMedecinControleRole ||
        this.hasAssistante
      );
    },
  },
  data() {
    return {
      isLoading: true,

      paginationOptions: {
        enabled: true,
        mode: "records",
        perPageDropdown: [3, 6, 10],
      },
    };
  },
  methods: {
    getMetriques() {
      this.isLoading = true;
      let args = {
        offset: this.offset,
        limit: this.limit,
      };

      this.$store.dispatch("getMetriques", { args: args }).then(() => {
        this.isLoading = false;
      });
    },
  },
  mounted() {
    this.getMetriques();
  },
};
</script>

<style scoped></style>
